import { defineStore } from "pinia";

import type { StickerType } from "@/model/StickerType";

export const useStickerTypeStore = defineStore("stickerType", {
  state: () => ({
    stickerTypes: [] as StickerType[],
  }),
  actions: {
    setStickerTypes(types: StickerType[]) {
      this.stickerTypes = types;
    },
  },
});
